import React, { createContext, useContext } from 'react';

function createSafeContext(errorMessage) {
  var Context = createContext(null);

  var useSafeContext = function useSafeContext() {
    var ctx = useContext(Context);

    if (ctx === null) {
      throw new Error(errorMessage);
    }

    return ctx;
  };

  var Provider = function Provider(_ref) {
    var children = _ref.children,
        value = _ref.value;
    return /* @__PURE__ */React.createElement(Context.Provider, {
      value: value
    }, children);
  };

  return [Provider, useSafeContext];
}

export { createSafeContext };